module.exports = __webpack_public_path__ + "search.svg?690fd10e998986e50ecf7537d2df790c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search.svg
// module id = 37
// module chunks = 0